// extracted by mini-css-extract-plugin
module.exports = {"customer-message-old-to-new":"customer-message-old-to-new-652601b42484cee05e42835a2629c381","reject-message":"reject-message-e5620ccd71eba1610456e35cfa41ad0b"};